import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tab-2-active",
  "use": "icon-tab-2-active-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-tab-2-active\">\n  <path id=\"icon-tab-2-active_路径_9310\" data-name=\"路径 9310\" d=\"M98.685,122.707l-5.189.249a2.772,2.772,0,0,0-1.826.808L84.832,130.6a1.564,1.564,0,0,0,0,2.21l5.437,5.437a1.564,1.564,0,0,0,2.21,0l.28-.28,1.806-1.806,4.75-4.75a2.772,2.772,0,0,0,.808-1.826l.249-5.189A1.613,1.613,0,0,0,98.685,122.707Zm-2.44,6.809a1.9,1.9,0,1,1,0-2.683A1.9,1.9,0,0,1,96.245,129.517Z\" transform=\"translate(-84.375 -122.705)\" fill=\"#becbdc\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tab-2-active.svg
// module id = Y0vf
// module chunks = 103